import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { WebsocketService } from '../../../../base/services/websockets/websocket.service';
import { MetadataOperation, OperationService } from '../../../../api';
import { CustomFields } from '../../../../api/model/customFields';
import { DialogDynSigData } from '../../../../models/interfaces';
import { cValidators } from '../../../../models/validator';
import { sigTypes } from '../../../../models/variables';
import { CertLoadedService } from '../../../../base/services/cert/cert-loaded.service';
import { MessageService } from '../../../../shared/message/message.service';
import { TranslateService } from '../../../../core/translation';
import { LoadSigTypeService } from '../../../../finish/types/dynsig/load-sig-type.service';
import { LoadSigTypeDirective } from '../../../../finish/types/dynsig/load-sig-type.directive';
import { IvSignProComponent } from '../ivsignpro/ivsignpro.component';
import { PersonalizationsService } from '../../../../base/services/personalizations/personalizations.service';
import { Environment } from '../../../../models/environment';
import { FinishProService } from '../../../../finish-pro/services/finish-pro.service';
import { ProfileService } from '../../../../core/profile/profile.service';
import { SamlService } from '../../../../services/saml.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * @title Stepper overview
 */
@Component({
  selector: 'dialog-diy-sig-pro',
  templateUrl: 'signpro.html',
  styleUrls: ['./signpro.scss'],
  providers: [LoadSigTypeService],
})
export class DialogDynSigPro implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('stepper') stepper: MatHorizontalStepper;
  @ViewChild('componentOne', { read: LoadSigTypeDirective }) compHost: LoadSigTypeDirective;
  @ViewChild('componentTwo', { read: LoadSigTypeDirective }) compHost2: LoadSigTypeDirective;
  @ViewChild('componentThree', { read: LoadSigTypeDirective }) compHost3: LoadSigTypeDirective;

  @Output() onFinish = new EventEmitter<MetadataOperation[]>();
  @Output() onError = new EventEmitter<any>();

  sigType = '';
  sigTypes: any = sigTypes;
  sigTypesKeys: string[] = Object.keys(this.sigTypes);

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  formConfig: string;
  operation: any;
  stepsLength: number;
  hasSecondStep = false;
  hasThirdStep = true;
  hasFourthStep = false;
  stepsCounter = 0;
  showStepper = false;
  componentRef: any;
  componentRef2: any;
  componentRef3: any;
  metadata = [];
  signer: any = false;
  title = 'dialog_sign_title';
  widget: any = null;
  customField: any = null;
  btnLabel = 'btn_label_next';
  clearBtnLabel = '';
  samlBtnLabel = 'login_btn_saml';
  notice = '';
  close = false;

  /**
   * String that saves the routeQR when is a dynamic sign operation
   */
  dynamicQR: string = '';

  actualStep: number;
  secondStep: number;
  thirdStep: number;
  fourthStep: number;

  /**
   * Connect webSocket
   */
  webSocket: WebSocket;
  sendedOTP = false;
  dynSig = false;

  customEvents: boolean;
  /**
   * Sctivate or deactivate the button to sign the operation
   */
  disableButtonSign: boolean = false;
  /**
   * Verify if setting of pressure is active
   */
  verifyPressure: number;
  /**
   * Disable button if pressure setting is active and device not compatible
   */
  blockSigbio: boolean = false;

  /**
   * Variable that contains the url
   */
  routeQR: string = '';

  /**
   * Variable that contains the url
   */
  routeQRAux: string = '';

  /**
   * Variable that contains the gesture
   */
  gestureWebSocket: string = '';
  /**
   * Variable that contains the gesture
   */
  configWebSocket;

  /**
   * Variable that contains the default gesture
   */
  saveNewSignature: string = '';

  /**
   * Variable that contains the extern url
   */
  otherCode: string = '';

  /**
   * QR propreties
   */
  elementType = NgxQrcodeElementTypes.URL;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;

  /**
   * Number that contains the number of websocket connections opened
   */
  countConnections: number = 0;

  /**
   * Array that contains ids of every operation that comes from websocket
   */
  messages: string[] = [];

  /**
   * String that saves the actual id of websocket connection
   */
  actualId: string = '';

  /**
   * String that contains the name of the cert preselected
   */
  nameCert: string;

  showLoader: boolean = false;

  isLocalSign: boolean = false;

  onlyLoginSAMLSIG: boolean;

  tokenIvSign: string;

  labelButtonSAML: string = '';

  environment: Environment;

  _transParam: boolean = false;

  hasTokenSAML: boolean = false;

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public dialogRef: MatDialogRef<DialogDynSigPro>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDynSigData,
    private _formBuilder: FormBuilder,
    private componentFactoryResolver: ComponentFactoryResolver,
    private loadTypeService: LoadSigTypeService,
    private webSocketService: WebsocketService,
    private _certLoaded: CertLoadedService,
    private ref: ChangeDetectorRef,
    public _router: Router,
    public _dialog: MatDialog,
    public _message: MessageService,
    public _translate: TranslateService,
    public _finishProService: FinishProService,
    public _operation: OperationService,
    public _profile: ProfileService,
    public _samlService: SamlService,
    private _personalization: PersonalizationsService
  ) {
    this.environment = this._personalization.sendEnv;
    this.onlyLoginSAMLSIG = this.environment.features?.onlyLoginSAMLSIG;
    this.labelButtonSAML = this.environment.features?.labelButtonSAML;
    this.customEvents = this.environment?.features.customEvents || false;
    this.data = data;
    if (data.widgets && data.widgets.length) {
      this.widget = null;
      this.checkWidgets(data.widgets);
    }
    this.verifyPressure = data.verifyPressure;
    this.sigTypesKeys = data.sigTypes;
    this.sigType = data.sigType;
    this.countSteps();

    this.secondStep = 1;
    this.thirdStep = 2;
    this.fourthStep = 3;
    if (!this.hasSecondStep) {
      this.thirdStep = 1;
      this.fourthStep = 2;
    }
    if (data.isDynSig) {
      this.dynSig = true;
    }
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.firstFormGroup = this._formBuilder.group({
      SIG_TYPE: [this.data.sigType, cValidators.required],
    });
    this.secondFormGroup = this._formBuilder.group({
      step: [null, cValidators.required],
    });
    this.thirdFormGroup = this._formBuilder.group({
      step: [null, cValidators.required],
    });
    this.firstFormGroup.updateValueAndValidity();
    this.nameCert = this._certLoaded.getNameCert();
  }

  ngOnDestroy(): void {
    this.dialogRef.close();
    this.destroy$.unsubscribe();
  }

  ngAfterViewInit(): void {
    const subTokenIvSign = this._samlService.tokenIvSign.subscribe((response: string) => {
      this.tokenIvSign = response;
      subTokenIvSign.unsubscribe();
    });

    const subHasTokenSAML = this._samlService.hasTokenSAML.subscribe((response: boolean) => {
      this.hasTokenSAML = response;
      subHasTokenSAML.unsubscribe();
    });

    this.webSocketService.activateWebSocket();
    this.webSocket = this.webSocketService.getWebSocket();
    this.routeQR = window.location.href;
    if (this.firstFormGroup.valid) {
      if (!this.customField) {
        this.loadThird();
      } else {
        this.loadSecond();
      }
    }

    this.webSocket.addEventListener('close', (data) => {
      if (this.componentRef) {
        this.componentRef.routeQR = '';
      }
      if (this.componentRef2) {
        this.componentRef2.routeQR = '';
      }
      if (this.componentRef3) {
        this.componentRef3.routeQR = '';
      }

      document.getElementById('hiddenWeb').style.display = 'none';
    });

    this.webSocket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      switch (data.Action) {
        case 'Connected': {
          this.countConnections = 0;
          if (this.dynSig) {
            this.dynamicQR = window.location.href + '/webSocketOperation?id=' + data.Message;
          } else {
            this.componentRef2.routeQR = window.location.href + '/webSocketOperation?id=' + data.Message;
          }
          this.actualId = data.Message;
          if (!this.dynSig) {
            this.routeQRAux = this.componentRef2.routeQR;
          }
          break;
        }
        case 'Linked':
          this.countConnections++;
          this.otherCode = data.Message;
          this.messages.push(this.otherCode);
          if (this.countConnections > 1) {
            this.webSocket.send(
              this.otherCode + '#' + JSON.stringify({ Action: 'Disconnected', Message: 'Duplicate' })
            );
          } else {
            document.getElementById('hiddenWeb').style.display = 'block';
            this.webSocket.send(this.otherCode + '#' + JSON.stringify({ Action: 'Linked', Message: this.actualId }));
          }
          break;
        case 'Sign':
          if (data.Message.includes('saveNewSignature')) {
            this.saveNewSignature = data.Message.split('___')[0];
            this.gestureWebSocket = data.Message.split('___')[1];
          } else {
            this.gestureWebSocket = data.Message.split('___')[0];
            this.configWebSocket = data.Message.split('___')[1];
          }
          this.next();
          break;
        case 'Finished':
          break;
        case 'Cancel':
          break;
        case 'UnknownReceiver':
          document.getElementById('hiddenWeb').style.display = 'none';
          break;
        case 'Disconnected':
          this.messages.forEach((element, index) => {
            if (element === data.Message) {
              this.countConnections--;
              this.messages.splice(index, 1);
            }
          });
          if (this.countConnections <= 0) {
            document.getElementById('hiddenWeb').style.display = 'none';
          } else {
            document.getElementById('hiddenWeb').style.display = 'block';
          }
          break;
      }
    };
  }

  next(): void {
    if (this.close && !this._finishProService.isLocalSign) {
      this.dialogRef.close();
      return;
    }
    this.showLoader = true;
    if (this.hasSecondStep) {
      switch (this.stepper.selectedIndex) {
        case 0:
          this.second();
          break;
        case 1:
          this.third();
          break;
        case 2:
          this.fourth();
          break;
      }
    } else {
      switch (this.stepper.selectedIndex) {
        case 0:
          this.third();
          break;
        case 1:
          this.fourth();
          break;
      }
    }
  }

  onStepChange(event: any): void {
    if (this.actualStep != event.selectedIndex) {
      if (this.hasSecondStep) {
        switch (event.selectedIndex) {
          case 0:
            this.reloadSecond();
            break;
          case 1:
            this.loadThird();
            break;
          case 2:
            this.loadFourth();
            break;
        }
      } else {
        switch (event.selectedIndex) {
          case 0:
            this.loadThird();
            break;
          case 1:
            this.loadFourth();
            break;
        }
      }
    }
  }

  closeModal(): void {
    this._finishProService.isLocalSign = false;
    this.webSocketService.closeWebSocket();
  }

  setSignType(type: string): void {
    this.sigType = type;
    this.firstFormGroup.get('SIG_TYPE').patchValue(type);
    this.firstFormGroup.updateValueAndValidity();
    if (!this.customField) {
      this.loadThird();
    } else {
      this.loadSecond();
    }
  }

  reloadSecond(): void {
    this.btnLabel = 'btn_label_next';
    this.clearBtnLabel = 'btn_limpiar';
    this.notice = '';
  }

  loadSecond(): void {
    const compName = 'FORM';
    let comp = null;
    this.actualStep = 0;
    if (!this.hasThirdStep) {
      this.btnLabel = 'finish_acep_btn_firmar';
    }
    this.clearBtnLabel = 'btn_limpiar';
    this.notice = '';
    this.title = this.sigTypes[this.sigType].label;
    comp = this.loadTypeService.getComponents()[compName];
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(comp);
    const viewContainerRef = this.compHost.viewContainerRef;
    if (viewContainerRef && viewContainerRef.clear) {
      viewContainerRef.clear();
    }
    const componentRef = viewContainerRef.createComponent(componentFactory);
    this.componentRef = componentRef.instance;

    this.componentRef.loadView();

    if (this.componentRef.onError) {
      this.componentRef.onError.pipe(takeUntil(this.destroy$)).subscribe((result) => {
        this.emitError(result);
      });
    }
    this.ref.detectChanges();
  }

  loadThird(): void {
    if (!this.hasSecondStep) {
      this.actualStep = 0;
    } else {
      this.actualStep = 1;
    }
    this.stepper.next();
    this.btnLabel = 'finish_acep_btn_firmar';
    this.clearBtnLabel = '';
    this.title = this.sigTypes[this.sigType].label;
    const data: any = {
      id: this.data.id,
    };

    data.formData = this.data.formData;
    data.widget = this.data.widgets;
    data.pdfs = this.data.pdfs;
    data.signGraffic = this.data.signGraffic;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(IvSignProComponent);
    const viewContainerRef = this.compHost2.viewContainerRef;
    if (viewContainerRef && viewContainerRef.clear) {
      viewContainerRef.clear();
    }
    const componentRef2 = viewContainerRef.createComponent(componentFactory);
    this.componentRef2 = componentRef2.instance;

    this.componentRef2.loadView();
    this.componentRef2.setData(data);
    if (this.dynSig) {
      this.componentRef2.routeQR = this.dynamicQR;
    }

    const external = this.environment.signature._default === 2;
    if (external) {
      this.btnLabel = 'tareasusuario_ivdesk_continuar';
      if (this.hasFourthStep) {
        this.hasFourthStep = false;
      }
    } else if (this.componentRef2.display === 1) {
      this.btnLabel = 'ivsign_btn_login';
    } else if (this.hasFourthStep) {
      this.btnLabel = 'btn_label_next';
    }
    this.componentRef2.setExternal(external);
    this.componentRef2.setAllowChange(this.environment.signature._internal && this.environment.signature.external);
    this.notice = this.componentRef2.getNotice();
    this.componentRef2.onNoCert.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.btnLabel = 'finish_btn_close';
      this.close = true;
    });

    this.componentRef2.onLoadFinish.pipe(takeUntil(this.destroy$)).subscribe((result: boolean) => {
      this.showLoader = result;
    });

    if (this.componentRef2.onError) {
      this.componentRef2.onError.pipe(takeUntil(this.destroy$)).subscribe((result) => {
        this.emitError(result);
      });
    }
    this.ref.detectChanges();
  }

  emitError(error): void {
    if (error === null) {
      return;
    }
    this.showLoader = false;
    this.onError.emit(error);
  }

  second(): void {
    this.doneSecond();
  }

  third(): void {
    if (this.componentRef2.ivDeskSign && this.componentRef2.localSign) {
      this.isLocalSign = true;
      this.componentRef2.getExternalUrl([this.data.id], (result) => {
        document.location.href = result;
        setInterval(() => {
          this._operation
            .operationGetOperationDetail(this._finishProService.operationId, this._profile.getToken())
            .then((res) => {
              const operationState = res.data.idEstado;
              if (operationState == 2) {
                this.dialogRef.close();
                this._router.navigate(['tasks/pending']);
              }
            });
        }, 30000);
      });
    }
    switch (this.componentRef2.display) {
      case 1:
        this.componentRef2.login();
        this.btnLabel = this.hasFourthStep ? 'btn_label_next' : 'finish_acep_btn_firmar';
        break;
      case 2:
        this.doneThird();
        break;
    }
  }

  doneSecond(): void {
    this.secondFormGroup.get('step').patchValue(true);
    this.secondFormGroup.get('step').updateValueAndValidity();

    this.metadata = this.componentRef?.fillForm();
    this.loadThird();
  }

  doneThird(skip?: boolean): void {
    if (this.otherCode !== '') {
      this.metadata.push({ key: 'code', value: this.otherCode });
    }
    this.thirdFormGroup.get('step').patchValue(true);
    this.thirdFormGroup.get('step').updateValueAndValidity();
    if (this.hasFourthStep && !skip) {
      this.loadFourth();
    } else {
      if (!this.signer) {
        this.componentRef2.metadataDocument = this.data.metadataDocument;
        this.signer = this.componentRef2.SendDocuments.pipe(takeUntil(this.destroy$)).subscribe((result) => {
          for (let i = 0; i < result.length; i++) {
            this.metadata.push({ key: result[i].idDocument, value: result[i].b64 });
          }

          this.finish(this.metadata);
        });
      }
      const sign2 = this.componentRef3
        ? this.gestureWebSocket === ''
          ? this.componentRef3.getSignature()
          : this.saveNewSignature === ''
          ? [{ key: 'firma_imagen', value: this.gestureWebSocket }]
          : [
              { key: 'firma_imagen', value: this.gestureWebSocket },
              { key: 'saveNewSignature', value: '1' },
            ]
        : null;
      if (sign2) {
        this.componentRef2.setSignature(sign2[0].value);

        for (const sign of sign2) {
          if (sign.key == 'saveNewSignature') {
            this.metadata.push({ key: sign.key, value: sign.value });
          }
        }
      }

      this.componentRef2.sign();
    }
  }

  checkWidgets(widgets: any[]): void {
    if (widgets.length) {
      for (const widget of widgets) {
        const design = widget.design;
        const toArray = JSON.parse(design);
        const onlyText = toArray.onlyText;
        if (this.widget && !onlyText) {
          this.hasFourthStep = true;
        }
      }
    }
  }

  checkCustomFields(customFields: CustomFields[]): void {
    if (customFields.length) {
      for (const customField of customFields) {
        this.customField = customField;
      }
      if (this.customField) {
        this.hasSecondStep = true;
      }
    }
  }

  loadFourth(): void {
    if (!this.hasSecondStep) {
      this.actualStep = 1;
    } else {
      this.actualStep = 2;
    }
    this.btnLabel = 'finish_acep_btn_firmar';

    this.stepper.next();
    let comp = null;
    comp = this.loadTypeService.getComponents()['SIMPLE'];
    this.clearBtnLabel = 'btn_limpiar';

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(comp);
    const viewContainerRef = this.compHost3.viewContainerRef;
    if (viewContainerRef && viewContainerRef.clear) {
      viewContainerRef.clear();
    }
    const componentRef2 = viewContainerRef.createComponent(componentFactory);

    this.componentRef3 = componentRef2.instance;
    this.componentRef3.loadView();
    this.componentRef3.setData({});
    if (this.dynSig) {
      this.componentRef3.routeQR = this.dynamicQR;
    }
  }

  fourth(): void {
    this.doneThird(true);
  }

  clear(): void {
    const stepIndex = this.stepper.selectedIndex;
    const componentsMap = this.getComponentsByStep();

    const component = componentsMap[stepIndex];
    if (component?.clear) {
      component.clear();
    }
  }

  private getComponentsByStep(): { [key: number]: any } {
    return this.hasSecondStep
      ? {
          0: this.componentRef,
          1: this.componentRef2,
          2: this.componentRef3,
        }
      : {
          0: this.componentRef2,
          1: this.componentRef3,
        };
  }

  finish(metadata): void {
    if (this.data.sigTypes.length > 1 || this.dynSig) {
      metadata.push({ key: 'SIG_TYPE', value: this.sigType });
    }

    this.onFinish.emit(metadata);
  }

  onNoticeClick(): void {
    this.componentRef2.onNoticeClick();
    this.notice = this.componentRef2.getNotice();
    if (this.componentRef2.external) {
      this.onlyLoginSAMLSIG = false;
      this.hasFourthStep = false;
      this.btnLabel = 'tareasusuario_ivdesk_continuar';
      this.close = false;
    } else {
      this.onlyLoginSAMLSIG = this.environment.features.onlyLoginSAMLSIG;
      if (this.componentRef2.cert.options) {
        this.close = true;
      }
      if (this.widget) {
        this.checkWidgets([this.widget]);
      }
      if (this.componentRef2.display === 1) {
        this.btnLabel = 'ivsign_btn_login';
      } else if (this.hasFourthStep) {
        this.btnLabel = 'btn_label_next';
      } else if (this.componentRef2.display === 2) {
        this.btnLabel = 'finish_acep_btn_firmar';
      }
    }
  }

  countSteps(): void {
    if (this.hasSecondStep) {
      this.stepsCounter++;
    }
    if (this.hasThirdStep) {
      this.stepsCounter++;
    }
    if (this.hasFourthStep) {
      this.stepsCounter++;
    }
    if (this.stepsCounter >= 2) {
      this.showStepper = true;
    }
  }

  redirectSAML(): void {
    if (this._finishProService.termsAccepted) {
      localStorage.setItem('terms', 'accepted');
    }
    this._samlService.routeSAML(this.data.id);
  }
}
